export default "/app/c656b8caa454ed19b9a2ef7f4f5b8fea.ttf";